// Optimized main.js - Defer non-critical functionality
// jquery-match-height moved to on-demand.js to reduce main bundle size

// Critical functionality - Load immediately
$("body").on("click", ".page-scroll", function (c) {
  const a = $(this);
  const _opened = $(".navbar-collapse").hasClass("collapse in");
  if (_opened === true) {
    $("button.navbar-toggle").trigger("click");
  }
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $(a.attr("href")).offset().top - 100,
      },
      1500,
      "easeInOutExpo"
    );
  c.preventDefault();
});

$(".scrollTop").on("click", "a.btn-up", function (e) {
  e.preventDefault();
  $("html, body").stop().animate(
    {
      scrollTop: 0,
    },
    1500,
    "easeInOutExpo"
  );
});

// Load non-critical Bootstrap components on demand
const loadBootstrapExtras = () => {
  const script = document.createElement("script");
  script.src = "/js/vendor/bootstrap-extra.js";
  script.async = true;
  script.onload = () => {
    if (window.initBootstrapExtras) {
      window.initBootstrapExtras();
    }
  };
  document.head.appendChild(script);
};

// Defer non-critical functionality until after page load
$(document).ready(function () {
  // Load bootstrap extras after a short delay
  setTimeout(loadBootstrapExtras, 100);

  // Defer tooltip initialization
  setTimeout(() => {
    if ($('.page-scroll__phone [data-toggle="tooltip"]').length) {
      $('.page-scroll__phone [data-toggle="tooltip"]').tooltip();
    }
  }, 200);

  // Defer form handlers
  setTimeout(() => {
    $("#email-address-home-2").on("focus", function () {
      $("#btn-signup-form-2").button("reset");
    });

    $("#btn-signupnow").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });
  }, 200);

  // Defer scroll-to functionality
  setTimeout(() => {
    $("a.scroll-to").on("click", function (e) {
      if (this.hash !== "") {
        e.preventDefault();
        var hash = this.hash;

        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top - $("nav.navbar").outerHeight(),
          },
          800,
          function () {
            window.location.hash = hash;
          }
        );
      }
    });
  }, 300);

  // Defer Intercom integration
  setTimeout(() => {
    $(".btn-intercom").on("click", function (e) {
      e.preventDefault();
      if (window.loadIntercom) {
        window.loadIntercom(function () {
          if (typeof Intercom === "function") {
            Intercom("showNewMessage");
          }
        });
      } else if (typeof Intercom === "function") {
        Intercom("showNewMessage");
      }
    });
  }, 500);

  // Defer popover initialization
  setTimeout(() => {
    $("#vip").popover({
      html: true,
      trigger: "hover focus",
      template:
        '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title" style="font-size: 16px; text-align: center;" ></h3><div class="popover-content" style="text-align: center;"></div></div>',
    });
  }, 1000);
});

// Optimize scroll handler to avoid layout thrashing
(() => {
  let ticking = false;
  let lastScrollY = 0;
  const scrollThreshold = 100; // Only update every 100px of scroll

  const onScroll = () => {
    const currentScrollY =
      window.pageYOffset || document.documentElement.scrollTop || 0;

    // Only process if scrolled enough
    if (Math.abs(currentScrollY - lastScrollY) < scrollThreshold) {
      ticking = false;
      return;
    }

    lastScrollY = currentScrollY;

    const win = window;
    const s = currentScrollY;
    const d =
      document.documentElement.scrollHeight || document.body.scrollHeight || 1;
    const c = win.innerHeight || document.documentElement.clientHeight || 1;

    const scrollPercent = (s / (d - c)) * 100;
    const target = $(".scrollTop");

    // Use class toggle instead of direct CSS manipulation for better performance
    if (scrollPercent >= 2) {
      target.addClass("visible");
    } else {
      target.removeClass("visible");
    }
    ticking = false;
  };

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScroll);
      }
    },
    { passive: true }
  );
})();

// Enhanced lazy loading with intersection observer
const imageObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        img.classList.remove("lazy");
        img.classList.add("loaded");
        imageObserver.unobserve(img);
      }
    });
  },
  {
    rootMargin: "50px 0px",
    threshold: 0.01,
  }
);

// Observe all lazy images
document.querySelectorAll("img.lazy").forEach((img) => {
  imageObserver.observe(img);
});

// Show lazy elements
$("img.lazy").show();
$("h2.lazy").show();
